import { KeyValue } from "@/main/models/common";
import { CultureTypes, CultureActionTypes } from "./cultureTypes";
import { CultureFilterRequest } from "@/main/models/request/cultureRequest";

export function getCulture(request: CultureFilterRequest): CultureActionTypes {
	return {
		type: CultureTypes.GET_CULTURE,
		payload: {
			request,
		},
	};
}

export function saveCulture(
	data: KeyValue[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): CultureActionTypes {
	return {
		type: CultureTypes.SAVE_CULTURE,
		payload: { data, isError, errorMessages },
	};
}

export function resetReducerCulture(): CultureActionTypes {
	return {
		type: CultureTypes.RESET_REDUCER_CULTURE,
	};
}
